export default __webpack_public_path__ + "static/9-23c91c946e1306d8a6b94c575ead0ec9.png";